import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';


export const Wrapper = styled.div`
    display: block;
    width: ${({ isSideBar }) => isSideBar ? 'calc(100% - 20px)' : '100%'};
    margin: 0 auto;
    max-width: ${p => p.maxWidth ? p.maxWidth : '680px'};
    background-color: ${p => p.backgroundColor ? p.backgroundColor : COLORS.white};
    @media(max-width: 680px) {
        width: calc(100% - 20px);
    }
`;

export const Title = styled.div`
    display: block;
    font-family: ${FONTS.light}, Arial, Helvetica, sans-serif;
    font-size: ${({ isSideBar }) => isSideBar ? '20px' : '24px'};
    line-height: 1.3;
    color: ${COLORS.black};
    margin-bottom: ${({ isSideBar }) => isSideBar ? '15px' : '33px'};
    @media(max-width: 530px) {
        font-size: 20px;
        margin-bottom: 15px;
    }
`;

export const CheckListBlock = styled.div`
    display: block;
    margin-bottom: ${({ isSideBar }) => isSideBar ? '15px' : '33px'};
    @media(max-width: 530px) {
        margin-bottom: 15px;
    }
`;
